(function($) {
    var numSlick = 0;

    // Carousel slider
    $('.slider-hero').each( function() {
        numSlick++;

        $(this).addClass( 'slider-' + numSlick ).slick({
            accessibility: false,
            arrows: false,
            dots: true,
            fade: true,
            infinite: true,
            slide: '.slider-item',
            slidesToScroll: 1,
            slidesToShow: 1,
        });
    });

})(jQuery);



// WEBPACK FOOTER //
// ./js/src/app/sliders.js